// @ts-strict-ignore
import React, { useEffect } from "react";

import { TopNavigationMenu } from "@braze/beacon-labs-navigation";
import { useI18nLocale } from "@braze/i18n-core";

import useI18nNamespace from "@services/useI18nNamespace";

import { useBrazeFreeTrialSdk } from "@scenes/FreeTrial/hooks";
import { LanguagePickerMenuItems } from "@scenes/TopNavigation/components/LanguagePickerMenuItems";

import { localeToLanguageMap } from "../../../../../locales";

const LOGGER_EVENT = "pm.trial_registration_language_event";

export const LanguagePicker = () => {
  const currentLocale = useI18nLocale();
  const { logBrazeFreeTrialEvent } = useBrazeFreeTrialSdk();
  const { t } = useI18nNamespace("free-trial-registration");

  useEffect(() => {
    const storedLocale = localStorage.getItem("i18nextLng"); // i18nextLng is the key used by i18next to store the current locale
    const lastTrackedLocale = localStorage.getItem("lastTrackedLanguage"); // key created by us to track the last tracked locale

    if (lastTrackedLocale && lastTrackedLocale !== storedLocale) {
      logBrazeFreeTrialEvent(LOGGER_EVENT, {
        type: "selected",
        language: storedLocale,
      });
      localStorage.setItem("lastTrackedLanguage", storedLocale);
    }
  }, [logBrazeFreeTrialEvent]);

  const handleMenuOpen = () => {
    logBrazeFreeTrialEvent(LOGGER_EVENT, {
      type: "opened",
    });
  };

  const handleMenuDismiss = () => {
    logBrazeFreeTrialEvent(LOGGER_EVENT, {
      type: "dismissed",
    });
  };

  return (
    <TopNavigationMenu
      buttonId="language-selector-button"
      menuId="language-selector-menu"
      icon="globe"
      buttonClassName="language-picker-button"
      placement="bottom-end"
      tooltip={t("select-locale", "Select your language ({language} language active)", {
        language: localeToLanguageMap[currentLocale].localizedName,
        placement: "left",
      })}
      aria-label={t("select-locale", "Select your language ({language} language active)", {
        language: localeToLanguageMap[currentLocale].localizedName,
      })}
      onOpen={handleMenuOpen}
      onClose={handleMenuDismiss}
    >
      <LanguagePickerMenuItems />
    </TopNavigationMenu>
  );
};
